<template>
  <router-link
    :to="href"
    class="paginated-list-link"
  >
    {{ text }}
  </router-link>
</template>
<script lang="ts" setup>
  defineProps({
    text: { type: String, required: true },
    href: { type: String, required: true },
    fontSize: { type: String, required: false, default: '1.2em' }
  });
</script>
<style lang="scss">
.paginated-list-link {
  font-size: v-bind(fontSize);
}
</style>